// @flow

import * as React from 'react';
import type { Region } from './types';
import PosListItem from './PosListItem';
import styles from './PosRegion.less';

type Props = {
  region: Region,
  currentLocale: string,
};

const PosRegion = ({ region, currentLocale }: Props) => (
  <li>
    <div className={styles.regionHeading}>{region.name}</div>
    <ul>
      {region.pointOfSales.map(pos => (
        <PosListItem pos={pos} key={pos.url} currentLocale={currentLocale} />
      ))}
    </ul>
  </li>
);

export default PosRegion;
